const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://apicabaza.creago.be/rest/cabaza';
const DEFAULT_API_KEY = 'cabaza_api_key_2024_change_me';

function headers() {
    return {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-API-Key': DEFAULT_API_KEY
    };
}

export const getActiveFaq = async (lang = 'fr', category = '') => {
    const qs = new URLSearchParams({ lang });
    if (category) qs.set('category', category);
    const res = await fetch(`${API_BASE_URL}/faq/active?${qs.toString()}`, {
        method: 'GET',
        headers: headers()
    });
    const data = await res.json();
    return data.data || data.DATA || [];
};
